import { useState, useEffect } from "react";
import axios from "axios";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { MessageCircle, Check, Eye, EyeOff, Wifi } from "lucide-react";
import { toast } from "../components/ui/sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function OwnerIntegracoesPage() {
  const [sysSettings, setSysSettings] = useState({ base_url: "", api_key: "" });
  const [showApiKey, setShowApiKey] = useState(false);
  const [savingSettings, setSavingSettings] = useState(false);

  useEffect(() => {
    axios.get(`${API}/owner/system-settings`, { withCredentials: true })
      .then(res => setSysSettings(res.data)).catch(() => {});
  }, []);

  const saveSystemSettings = async () => {
    setSavingSettings(true);
    try {
      await axios.put(`${API}/owner/system-settings`, sysSettings, { withCredentials: true });
      toast.success("Configurações salvas!");
    } catch { toast.error("Erro ao salvar"); }
    finally { setSavingSettings(false); }
  };

  return (
    <div data-testid="owner-integracoes-page" className="space-y-6">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg bg-indigo-50 flex items-center justify-center">
          <Wifi className="w-5 h-5 text-indigo-600" strokeWidth={1.5} />
        </div>
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold font-heading text-slate-900 tracking-tight">Integrações</h1>
          <p className="text-slate-500 mt-0.5">Configurações globais de integrações da plataforma.</p>
        </div>
      </div>

      <Card className="bg-white border-slate-200 shadow-sm">
        <CardHeader className="pb-3">
          <CardTitle className="text-base font-heading text-slate-900 flex items-center gap-2">
            <div className="w-7 h-7 rounded-lg flex items-center justify-center" style={{ backgroundColor: "#25D36618" }}>
              <MessageCircle className="w-4 h-4" style={{ color: "#25D366" }} />
            </div>
            Configurações Globais — Evolution API (WhatsApp)
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <p className="text-xs text-slate-500">Configure o servidor Evolution API. Cada tenant poderá ativar/desativar sua própria instância WhatsApp.</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <Label className="text-slate-700 text-sm">URL Base do Servidor</Label>
              <Input
                data-testid="owner-evo-base-url"
                value={sysSettings.base_url}
                onChange={e => setSysSettings({ ...sysSettings, base_url: e.target.value })}
                placeholder="https://evolution.seudominio.com"
                className="mt-1"
              />
            </div>
            <div>
              <Label className="text-slate-700 text-sm">API Key</Label>
              <div className="relative mt-1">
                <Input
                  data-testid="owner-evo-api-key"
                  type={showApiKey ? "text" : "password"}
                  value={sysSettings.api_key}
                  onChange={e => setSysSettings({ ...sysSettings, api_key: e.target.value })}
                  placeholder="••••••••"
                  className="pr-9"
                />
                <button type="button" onClick={() => setShowApiKey(v => !v)}
                  className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600">
                  {showApiKey ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>
          </div>
          <Button data-testid="owner-evo-save-btn" onClick={saveSystemSettings} disabled={savingSettings} size="sm"
            className="bg-indigo-600 text-white hover:bg-indigo-700">
            <Check className="w-4 h-4 mr-2" />{savingSettings ? "Salvando..." : "Salvar Configurações"}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
